import React, { forwardRef } from "react";
import { ThumbUpOutlineIcon } from "@activecollab/components";
import PropTypes from "prop-types";

export const InitialReaction = forwardRef(({ onClick, style }, ref) => (
  <div
    ref={ref}
    className="reaction initial"
    onClick={onClick}
    style={style}
  >
    <span className="initial">
      <ThumbUpOutlineIcon />
    </span>
  </div>
));

InitialReaction.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
};

InitialReaction.displayName = "InitialReaction";
